import {AnalysisGraphQL, AnalysisViewGraphQL} from 'analysis-tool/AnalysisTypes';
import {
  allParentViewsSucceeded,
  getEditViewRightSidebarItemForView,
  isFileView,
} from 'analysis-tool/data-view/AnalysisViewUtils';
import {ButtonDataViewAction} from 'analysis-tool/data-view/DataViewContext';
import {checkCanModifyStep} from 'analysis-tool/EditStepHelpers';
import isAnalysisReadOnly from 'analysis-tool/isAnalysisReadOnly';
import {
  AnalysisRightSidebarItem,
  AnalysisRightSidebarItemType,
} from 'analysis-tool/right-sidebar/RightSidebarTypes';
import {AnalysisMainViewItem, AnalysisMainViewItemType} from 'analysis-tool/ui/main-view/MainViewTypes';
import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';

export default function getEditViewAction(
  analysis: AnalysisGraphQL,
  view: AnalysisViewGraphQL,
  onChangeSelectedItem: (newSelectedItem: AnalysisMainViewItem) => void,
  onChangeSelectedRightSidebarItem: (newSelectedItem: AnalysisRightSidebarItem | null) => void,
  selectedRightSidebarItem: AnalysisRightSidebarItem | null
): ButtonDataViewAction | null {
  const lastNode = view.lineage[view.lineage.length - 1];
  if (
    isFileView(view) ||
    isAnalysisReadOnly(analysis) ||
    !allParentViewsSucceeded(analysis, view) ||
    selectedRightSidebarItem?.type === AnalysisRightSidebarItemType.EDIT_VIEW
  ) {
    return null;
  }

  const {canEdit: canEditView, message} = checkCanModifyStep(analysis, lastNode.step.id, 'view', false);

  return {
    icon: 'edit',
    onClick: () => {
      if (!canEditView) {
        return;
      }

      // Regression editing hasn't been moved to the new right side bar editor yet and still uses a bespoke
      // `AnalysisMainViewItem`, so we need to special case and switch the selected item instead of opening
      // the right sidebar editor.
      //
      // TODO(BNCH-135912): Remove regression special casing when regression is modernized to new views.
      if (lastNode.step.stepType === PipelineStepType.REGRESSION) {
        onChangeSelectedItem({type: AnalysisMainViewItemType.EDIT_REGRESSION, stepId: lastNode.step.id});
      } else {
        onChangeSelectedRightSidebarItem(getEditViewRightSidebarItemForView(view));
      }
    },
    helpText: canEditView ? 'Edit View' : message,
    isDisabled: !canEditView,
  };
}
